module.exports = __webpack_public_path__ + "img/editing_3.9538e0f4.png";